<script>
import { blogSlider } from './../../../static/js/main_vue.js';

import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'

export default {
  name: 'FAQ',
  components: {
    Footer,
    HeaderFive
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted()
  {
      blogSlider();
  }
}
</script>

<template>
  <div class="page faq-page">
    <HeaderFive />

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                           
                            <h1 class="section-title white-color">Frequently Asked Questions</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>FAQ</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- FAQ AREA START (faq-2) (ID > accordion_2) -->
    <div class="ltn__faq-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__faq-inner ltn__faq-inner-2">
                        <div id="accordion_2">
                            <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-1" aria-expanded="true">
                                  What is San Miguel Food Service?
                                </h6>
                                <div id="faq-item-2-1" class="collapse show" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>San Miguel Food Service is the official B2B platform of San Miguel Foods, Inc. This is created for food service accounts to learn more about SMFI’s products and discover how we can help you with your business. More importantly, food service accounts can now directly order SMFI products in the platform!</p>
                                    </div>
                                </div>
                            </div>
                            <!-- card -->
                            <div class="card">
                                <h6 class="ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-2" aria-expanded="false">
                                    How can I order in the website?
                                </h6>
                                <div id="faq-item-2-2" class="collapse " data-parent="#accordion_2">
                                    <div class="card-body">
                                         <p>You must register in the website before you can place an order.</p>
                                    </div>
                                </div>
                            </div>
                            <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-3" aria-expanded="false">
                                    Who can register in the website?
                                </h6>
                                <div id="faq-item-2-3" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>Food service accounts who are looking for a consistent and reliable supplier.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-4" aria-expanded="false">
                                    What are the requirements to register online?
                                </h6>
                                <div id="faq-item-2-4" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>We are accepting the following as proof of business registration – SEC Registration Number, BIR Registration Number, TIN or any the documents that will prove the existence of your business.</p>
                                    </div>
                                </div>
                            </div>
                            <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-5" aria-expanded="false">
                                  I’m a home-based entrepreneur, can I still register?
                                </h6>
                                <div id="faq-item-2-5" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>For micro and small entrepreneurs, you can upload your barangay and/or city business permit.</p>
                                    </div>
                                </div>
                            </div>
                            <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-6" aria-expanded="false">
                                  How long before I know the status of my registration?
                                </h6>
                                <div id="faq-item-2-6" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>Give us a day to review your registration. Our distributors may contact you if they have clarifications. While waiting, feel free to browse in the website, explore our wide selection of products, and learn from our culinary partners.</p>
                                    </div>
                                </div>
                            </div>
                            <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-7" aria-expanded="false">
                                   What products can be ordered in the website?
                                </h6>
                                <div id="faq-item-2-7" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>We have one of the widest product selection for food service – cheese, butter, margarine, milk, pre-mixed flour, coffee, frozen meats, frozen sauces, canned meats, ready-to-eat, and more.</p>
                                    </div>
                                </div>
                            </div>

                            <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-8" aria-expanded="false">
                                  Why are some SKUs not available?
                                </h6>
                                <div id="faq-item-2-8" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>There are many reasons why an SKU is not available for ordering in the platform. First, the SKU might not have inventory in your distributor’s warehouse. Second, some food service products with special packaging can only be sold offline. For clarifications, you can directly coordinate with your assigned distributor.</p>
                                    </div>
                                </div>
                            </div>

                             <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-9" aria-expanded="false">
                                   How long is the delivery lead time?
                                </h6>
                                <div id="faq-item-2-9" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>We are following the schedule of our distributors. Kindly give us a few days to fulfil your order. If you want your orders to have same day or next day delivery, you can contact our distributor.</p>
                                    </div>
                                </div>
                            </div>

                             <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-10" aria-expanded="false">
                                   How much is the delivery fee?
                                </h6>
                                <div id="faq-item-2-10" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>Delivery is FREE of charge!</p>
                                    </div>
                                </div>
                            </div>

                             <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-11" aria-expanded="false">
                                  Is there minimum order amount?
                                </h6>
                                <div id="faq-item-2-11" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>There is no minimum order amount for regular orders. For same day delivery, our distributors will reach out to you regarding minimum order amount.</p>
                                    </div>
                                </div>
                            </div>

                             <!-- card -->
                            <div class="card">
                                <h6 class="collapsed ltn__card-title" data-toggle="collapse" data-target="#faq-item-2-12" aria-expanded="false">
                                  Who can we contact for same-day or next day delivery?
                                </h6>
                                <div id="faq-item-2-12" class="collapse" data-parent="#accordion_2">
                                    <div class="card-body">
                                        <p>Cavite – 039670874535<br>
                                            Las Pinas, Taguig, Pateros – 09065044267<br>
                                            Makati, Paranaque, Pasay – 09386084255<br>
                                        </p>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="need-support text-center mt-100">
                            <h2>Still need help? Reach out to support 24/7:</h2>
                            <div class="btn-wrapper mb-30">
                                <router-link to="contact-us" class="theme-btn-1 btn">Contact Us</router-link>
                            </div>
                            
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <!-- FAQ AREA START -->

     <!-- BLOG AREA START (blog-3) -->
    <div class="ltn__blog-area pt-115 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2 text-center">
                        <h1 class="section-title white-color---">Latest Blog</h1>
                    </div>
                </div>
            </div>
            <div class="row  ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
                <!-- Blog Item -->
                <div class="col-lg-12">
                    <div class="ltn__blog-item ltn__blog-item-3">
                        <iframe width="300" height="300" src="https://www.youtube.com/embed/P1MSDQb2qHQ" title="Veega Meat-free Giniling Sotanghon Soup" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                </div>
                <!-- Blog Item -->
                <div class="col-lg-12">
                    <div class="ltn__blog-item ltn__blog-item-3">
                        <iframe width="300" height="300" src="https://www.youtube.com/embed/TRIIwr5No-E" title="Kare-kare on Crispy Noodles | Home Foodie #Madalicious" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                </div>
                <!-- Blog Item -->
                <div class="col-lg-12">
                    <div class="ltn__blog-item ltn__blog-item-3">
                        <iframe width="300" height="300" src="https://www.youtube.com/embed/RRKpyRzoGH4" title="THAI BEEF CALDERETA TOM YUM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                </div>
     
            </div>
        </div>
    </div>
    <!-- BLOG AREA END -->

    <Footer />

  </div>
</template>



// WEBPACK FOOTER //
// src/components/page/FAQ.vue